module.exports = "<div class=\"ic-pagination\">\n  <div class=\"ic-pagination__item\" (click)=\"previous()\" [class.ic-pagination__item--disable]=\"!hasPrevisous()\">&#8592;</div>\n  <div *ngFor=\"let i of pages\" (click)=\"gotoPage(i)\" class=\"ic-pagination__item\" [class.ic-pagination__item--active]=\"page == i\">{{i}}</div>\n  <div class=\"ic-pagination__item\" (click)=\"next()\" [class.ic-pagination__item--disable]=\"!hasNext()\">&#8594;</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/pagination/pagination.component.html
// module id = ./src/app/layout/pagination/pagination.component.html
// module chunks = main